
export default {

  historicalTemperatureAverageContext: new Map(),
  historicalTemperatureAverageStatus: new Map(),
  periodTemperatureAverageContext: new Map(),
  periodTemperatureAverageStatus: new Map(),
  currentTemperatureAverageContext: new Map(), 
  currentTemperatureAverageStatus: new Map(),

  historicalSPI4AverageContext: new Map(),
  historicalSPI4AverageStatus: new Map(),
  periodSPI4AverageContext: new Map(),
  periodSPI4AverageStatus: new Map(),
  currentSPI4AverageContext: new Map(), 
  currentSPI4AverageStatus: new Map(),

};
